import { useState } from 'react';

const galleryPhotos = [
  {
    id: 1,
    title: 'Torres del Paine',
    location: 'Patagonia',
    image: 'https://public.readdy.ai/ai/img_res/83d4a88bb48097db17a67a8767b88bb4.jpg',
  },
  {
    id: 2,
    title: 'Desierto de Atacama',
    location: 'Norte de Chile',
    image: 'https://readdy.ai/api/search-image?query=Atacama%20Desert%20Chile%20vast%20salt%20flats%20with%20colorful%20volcanic%20mountains%20at%20sunset%2C%20orange%20and%20red%20sky%2C%20dramatic%20arid%20landscape%2C%20unique%20geological%20formations%2C%20stunning%20natural%20scenery&width=600&height=400&seq=gal2&orientation=landscape',
  },
  {
    id: 3,
    title: 'Valle de la Luna',
    location: 'San Pedro de Atacama',
    image: 'https://readdy.ai/api/search-image?query=Valle%20de%20la%20Luna%20San%20Pedro%20de%20Atacama%20Chile%20surreal%20moon-like%20landscape%20with%20sand%20dunes%20and%20rock%20formations%2C%20warm%20golden%20sunset%20light%2C%20otherworldly%20terrain%2C%20dramatic%20shadows&width=600&height=400&seq=gal3&orientation=landscape',
  },
  {
    id: 4,
    title: 'Chiloé',
    location: 'Los Lagos',
    image: 'https://readdy.ai/api/search-image?query=Chiloe%20island%20Chile%20colorful%20wooden%20palafitos%20stilt%20houses%20over%20calm%20water%2C%20misty%20morning%20atmosphere%2C%20lush%20green%20hills%20in%20background%2C%20traditional%20architecture%2C%20reflections%20in%20water&width=600&height=500&seq=gal4&orientation=landscape',
  },
  {
    id: 5,
    title: 'Volcán Villarrica',
    location: 'La Araucanía',
    image: 'https://readdy.ai/api/search-image?query=Villarrica%20volcano%20Chile%20perfectly%20cone%20shaped%20snow%20covered%20active%20volcano%20reflected%20in%20pristine%20lake%2C%20lush%20forest%20surroundings%2C%20clear%20blue%20sky%2C%20dramatic%20natural%20scenery%2C%20Pucon%20region&width=600&height=500&seq=gal5&orientation=landscape',
  },
  {
    id: 6,
    title: 'Carretera Austral',
    location: 'Aysén',
    image: 'https://readdy.ai/api/search-image?query=Carretera%20Austral%20Chile%20scenic%20road%20through%20ancient%20temperate%20rainforest%20with%20turquoise%20river%2C%20dramatic%20mountains%2C%20lush%20vegetation%2C%20remote%20wilderness%2C%20adventure%20travel%20photography&width=800&height=500&seq=gal6&orientation=landscape',
  },
  {
    id: 7,
    title: 'Isla de Pascua',
    location: 'Rapa Nui',
    image: 'https://readdy.ai/api/search-image?query=Easter%20Island%20Rapa%20Nui%20Chile%20iconic%20Moai%20stone%20statues%20on%20green%20hillside%20with%20dramatic%20ocean%20sunset%20background%2C%20ancient%20mysterious%20culture%2C%20vibrant%20sky%20colors%2C%20Pacific%20Ocean&width=600&height=400&seq=gal7&orientation=landscape',
  },
];

export default function Gallery() {
  const [selected, setSelected] = useState<(typeof galleryPhotos)[0] | null>(null);

  return (
    <section id="galeria" className="py-16 md:py-32 px-4 md:px-8 bg-stone-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-12 md:mb-16 gap-6">
          <div>
            <p className="text-teal-600 text-sm font-semibold uppercase tracking-widest mb-3">
              Destination Gallery
            </p>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
              Chile in Images
            </h2>
            <div className="w-20 h-1 bg-teal-600"></div>
          </div>
          <p className="text-base md:text-lg text-gray-600 md:max-w-xl md:text-right leading-relaxed">
            Discover the incredible diversity of landscapes that Chile has to offer, from the driest desert to the most imposing glaciers.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-auto">
          {galleryPhotos.map((photo) => (
            <div
              key={photo.id}
              className="relative overflow-hidden rounded-2xl cursor-pointer group h-64 sm:h-72 lg:h-80"
              onClick={() => setSelected(photo)}
            >
              <img
                src={photo.image}
                alt={photo.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h3 className="text-white font-bold text-lg leading-tight">{photo.title}</h3>
                <div className="flex items-center text-white/80 text-sm mt-1">
                  <div className="w-4 h-4 flex items-center justify-center mr-1">
                    <i className="ri-map-pin-line text-sm"></i>
                  </div>
                  <span>{photo.location}</span>
                </div>
              </div>
              {/* Zoom icon */}
              <div className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line text-white text-base"></i>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selected && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 md:p-6"
          onClick={() => setSelected(null)}
        >
          <div
            className="relative max-w-4xl w-full rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selected.image}
              alt={selected.title}
              className="w-full h-auto max-h-[80vh] object-cover object-top"
            />
            <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 bg-gradient-to-t from-black/70 to-transparent">
              <h3 className="text-white text-xl md:text-2xl font-bold">{selected.title}</h3>
              <div className="flex items-center text-white/80 text-sm mt-1">
                <div className="w-4 h-4 flex items-center justify-center mr-1">
                  <i className="ri-map-pin-line text-sm"></i>
                </div>
                <span>{selected.location}</span>
              </div>
            </div>
            <button
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full text-white hover:bg-white/40 transition-colors cursor-pointer"
              onClick={() => setSelected(null)}
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
        </div>
      )}
    </section>
  );
}